/* unplugin-vue-components disabled */import { render } from "./icon-as-button.vue?vue&type=template&id=880232ee"
import script from "./icon-as-button.vue?vue&type=script&lang=js"
export * from "./icon-as-button.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/icon-as-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "880232ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('880232ee', __exports__)) {
    api.reload('880232ee', __exports__)
  }
  
  module.hot.accept("./icon-as-button.vue?vue&type=template&id=880232ee", () => {
    api.rerender('880232ee', render)
  })

}


export default __exports__